import React, { useState, useEffect } from 'react';

// --- Import your single, complete PNG logo ---
import yourFullLogo from '../assets/logo/logo-black-1.png'; 

const OpenerAnimation = ({ onFinished }) => {
  const [phase, setPhase] = useState('start'); // "start" -> "zooming" -> "finished"

  useEffect(() => {
    // Sequence of the animation
    const timer1 = setTimeout(() => setPhase('zooming'), 100);    // Start the zoom
    const timer2 = setTimeout(() => setPhase('finished'), 2500); // Animation is logically finished
    const timer3 = setTimeout(onFinished, 3000);                 // Remove the component from the DOM

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [onFinished]);

  return (
    // The main container will clip the animation and fade out
    <div className={`opener-container-zoom-in ${phase}`}>
      {/* The logo wrapper is the element that scales */}
      <div className="logo-wrapper">
        <img src={yourFullLogo} alt="Grams Coffee Logo" />
      </div>
    </div>
  );
};

export default OpenerAnimation;